import React from 'react';
import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts/LineChart';
import { Typography } from '@mui/material';

const margin = { right: 24 };

export interface SearchEngineDailyCount {
    queries: number;
    searchDate: string;
}

interface dailyCountSummaryProps {
    summary?: SearchEngineDailyCount[];
}


const SearchEngineDailyCountsChart = (props: dailyCountSummaryProps) => {

    let queriesData: number[] = [];
    let dates: string[] = [];

    if (props.summary) {
        let summary = props.summary;
        summary.forEach((data) => {
            queriesData.push(data.queries);
            dates.push(data.searchDate);
        }
        );
    }

    return (
        <Box sx={{ width: '100%', height: 325 }}>
            <Typography color={'blue'} variant="subtitle1" marginBottom={2}>
                Search # in the last 30 days
            </Typography>
            <LineChart
                series={[
                    {
                        data: queriesData,
                        label: 'Search Count',
                    },
                ]}
                yAxis={[
                    {
                        min: 0
                    },
                ]}
                xAxis={[{ scaleType: 'point', data: dates }]}
                margin={margin}
            />
        </Box>
    );
}

export default SearchEngineDailyCountsChart